import api from "../../../api";
import React from "react";
import utils from "../../../utils";
import values from "../../../values";
import Context from "../../../context";
import CompanyScreen from "..";

import { TModal } from "../../../types/common.type";
import { useQuery } from "react-query";
import { DeleteModal } from "../../../components";
import {
  IFindUserInformation,
  UpdateAbsent,
} from "../../../types/common.interface";
import { ICreateAndUpdateCompany } from "../../../types/company.interface";
import { AbsentScreen, LogScreen } from "../..";

const HistoryContainer = () => {
  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Value Validations
  // ** --------------------------------------------------------------------------------------------------------------------
  const [showModal, setShowModal] = React.useState<TModal>("NONE");
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedHistory, setSelectedHistory] = React.useState<any>();
  const [allCompanyInfo, setAllCompanyInfo] =
    React.useState<IFindUserInformation>({
      limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
      page: 1,
    });
  const [requestLog, setRequestLog] = React.useState<IFindUserInformation>({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
    search: { base: "", value: "" },
    filters: {
      province: undefined,
      city: undefined,
      superAgent: undefined,
    },
  });

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // !! ====================================================================================================================
  // !! --------------------------------------------------------------------------------------------------------------------
  // !!                                                Start API Cal
  // !! --------------------------------------------------------------------------------------------------------------------
  // ? Panel-wide academic year (سال تحصیلی). It has to be part of the query key as well as the request, otherwise
  // ? react-query serves the previous year's cached rows when the year is switched.
  const { selectedYear } = React.useContext(Context.AcademicYear);

  const resultHistory = useQuery(
    [
      values.useQueryKeys.getAllLog,
      requestLog?.page,
      requestLog?.search?.value,
      requestLog?.filters,
      selectedYear?._id,
    ],
    () =>
      api.post.common.findLog({
        filters: requestLog?.filters,
        search: requestLog?.search,
        limit: requestLog?.limit,
        page: requestLog?.page,
        academicYear: selectedYear?._id,
      })
  );
  const { refetch } = resultHistory;

  // !! --------------------------------------------------------------------------------------------------------------------
  // !! ====================================================================================================================

  // ** ====================================================================================================================
  // ** --------------------------------------------------------------------------------------------------------------------
  // **                                               Local Functions
  // ** --------------------------------------------------------------------------------------------------------------------

  // async function approveFunction(formData: UpdateAbsent) {
  //   setIsLoading(true);
  //   const result = await api.put.common.updateAbsent(formData);
  //   if (result) {
  //     utils.successHandler(Number(2010));
  //     refetch();
  //     setShowModal("NONE");
  //   }
  //   setIsLoading(false);
  //   return false;
  // }
  async function updateFunction(formData: UpdateAbsent) {
    setIsLoading(true);
    const result = await api.put.common.updateAbsent(formData);
    if (result) {
      utils.successHandler(Number(2010));
      refetch();
      setShowModal("NONE");
    }
    setIsLoading(false);
    return false;
  }

  // ** --------------------------------------------------------------------------------------------------------------------
  // ** ====================================================================================================================

  // ?? ====================================================================================================================
  // ?? --------------------------------------------------------------------------------------------------------------------
  // ??                                                JSX Container
  // ?? --------------------------------------------------------------------------------------------------------------------

  return (
    <Context.LogScreen.Provider
      value={{
        showModal,
        isLoading,
        setIsLoading,
        setShowModal,
        updateFunction,
        allCompanyInfo,
        selectedHistory,
        setAllCompanyInfo,
        setSelectedHistory,
        requestLog,
        setRequestLog,
        // approveFunction,
      }}
    >
      <LogScreen rqLog={resultHistory} role="ADMIN" />
    </Context.LogScreen.Provider>
  );

  // ?? --------------------------------------------------------------------------------------------------------------------
  // ?? ====================================================================================================================
};

export default HistoryContainer;
